import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { watchBuild } from './lib/build-watch.js';
import './styles/index.css';
import { App } from './App.js';
import { isStandalone, trackViewportHeight } from './lib/viewport.js';
import { isNative, reportWebBuild } from './lib/native.js';

trackViewportHeight();
// Running as an app (iOS shell or home-screen PWA): no text selection or long-press callouts (styles/base.css).
if (isNative() || isStandalone()) document.documentElement.dataset['app'] = '';
reportWebBuild();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Stale controls are worse than a reload, so new builds are taken immediately (lib/build-watch.ts).
if (import.meta.env.PROD) {
  if ('serviceWorker' in navigator) {
    registerSW({
      immediate: true,
      onRegisteredSW(_url, registration) {
        watchBuild(registration);
      },
      onRegisterError() {
        watchBuild();
      },
    });
  } else {
    // iOS app (WKWebView has no service workers).
    watchBuild();
  }
}
